import { cn } from '@rematter/ui-web';

export type ScaleTicketProViewProps = {
  children: React.ReactNode;
  className?: string;
};

export const ScaleTicketProView = ({
  children,
  className,
}: ScaleTicketProViewProps) => (
  <div className={cn('@ScaleTicketProView flex h-full flex-col', className)}>
    {children}
  </div>
);
